import { types, utils } from "@vilocnv/allsetra-core";
import {
  isInactiveObject,
  ObjectStatusValue,
  resolveObjectIconUrl
} from "app/data/helpers";
import { ObjectsMapMarker } from "../interfaces/object-state.interface";

export function mapObjectToMarker(
  object: types.IObject,
  statusOverride?: ObjectStatusValue
): ObjectsMapMarker | undefined {
  const {
    location,
    uniqueId = "",
    direction = 0,
    objectType,
    name = ""
  } = object;

  if (!location) return;

  const { latitude, longitude } = location;
  if (!latitude || !longitude || latitude === 0 || longitude === 0) {
    return;
  }

  const position = {
    lat: latitude - 0.00001,
    lng: longitude
  };
  const status = statusOverride ?? object?.status;
  const inactive = isInactiveObject(status);
  const rawIconUrl = objectType?.icon?.url || (object as any)?.icon?.url || "";
  const iconUrl = resolveObjectIconUrl(rawIconUrl, status);
  const icon = utils.getMapIcon(
    iconUrl,
    direction === 0 ? object?.lastReportedDirection : direction
  );

  return {
    uniqueId,
    position,
    icon,
    direction,
    name,
    status,
    isInactive: inactive
  };
}
